<template>
  <div>
    <h5 class="mb-5 questionlabel" v-if="question.question">{{ question.question }}</h5>

    <div class="vx-row my-5">
      <template v-if="isEditable">
        <div
          class="vx-col w-full mb-2"
          v-for="(answer, index2) in question.answers"
          :key="index2"
          :class="{ wrong: !answer.correct && value.includes(answer.val) }"
        >
          <vs-checkbox
            v-model="val"
            @input="handleInput"
            class="checkbox_answer multiline"
            :vs-value="answer.val"
            >{{ answer.answer }}</vs-checkbox
          >
        </div>
      </template>
      <div class="my-2 mx-5" v-else>
        <div
          class="vx-col w-full"
          v-for="(answer, index2) in question.answers"
          :key="index2"
          :class="{ 'wrong wrongro': !answer.correct && value.includes(answer.val) }"
        >
          <vs-checkbox
            disabled="true"
            v-model="val"
            class="checkbox_answer multiline"
            :vs-value="answer.val"
            >{{ answer.answer }}</vs-checkbox
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['question', 'value', 'isEditable', 'index'],
  computed: {
    val() {
      return this.$props.value;
    },
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
}
.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}
.scale-header {
  background: #f5f5f5;
  padding-top: 5px;
  font-weight: 600;
}
</style>
